// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Field from "../layout-and-structure/Field.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as TextArea from "../../primitives/TextArea.res.js";
import * as ReactAria from "react-aria";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as TextFieldStyle from "./TextFieldStyle.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function style(focused, hovered, errored, disabled) {
  return {
    backgroundColor: TextFieldStyle.backgroundColor(disabled),
    display: "flex",
    outline: "1px solid",
    outlineColor: TextFieldStyle.borderColor(focused, hovered, errored, disabled),
    borderRadius: TextFieldStyle.borderRadiusPx,
    outlineOffset: "-1px"
  };
}

function textAreaStyle(disabled) {
  return {
    backgroundColor: TextFieldStyle.backgroundColor(disabled),
    color: "#25243a",
    fontSize: TextFieldStyle.fontSizePx,
    padding: "10px" + ` ` + "12px",
    flex: "1",
    boxSizing: "border-box"
  };
}

function useFocus(focused, onFocus, onBlur, param) {
  if (focused !== undefined && onFocus !== undefined && onBlur !== undefined) {
    return [
      focused,
      onFocus,
      onBlur
    ];
  }
  let match = React.useState(() => false);
  let setFocused = match[1];
  let onFocus$1 = () => setFocused(param => true);
  let onBlur$1 = () => setFocused(param => false);
  return [
    match[0],
    onFocus$1,
    onBlur$1
  ];
}

function InputTextAreaField(props) {
  let errorMessage = props.errorMessage;
  let __disabled = props.disabled;
  let label = props.label;
  let disabled = __disabled !== undefined ? __disabled : false;
  let match = Hover.use(undefined, undefined, undefined);
  let match$1 = useFocus(props.focused, props.onFocus, props.onBlur, undefined);
  let props_label = Stdlib_Option.getOr(label, I18n.t("Textarea input field"));
  let props_aria$label = Stdlib_Option.getOr(label, I18n.t("Textarea input field"));
  let props$1 = {
    label: props_label,
    "aria-label": props_aria$label
  };
  let match$2 = ReactAria.useLabel(props$1);
  let ariaProps = ReactAria.mergeProps(props.ariaProps, match$2.fieldProps);
  let errored = Stdlib_Option.isSome(errorMessage);
  let style$1 = style(match$1[0], match[1], errored, disabled);
  let textAreaStyle$1 = textAreaStyle(disabled);
  return JsxRuntime.jsx(Field.make, {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(TextArea.make, {
        ariaProps: ariaProps,
        placeholder: props.placeholder,
        readOnly: disabled,
        style: textAreaStyle$1,
        value: props.value,
        onChange: props.onChange,
        onFocus: match$1[1],
        onBlur: match$1[2]
      }),
      style: style$1
    }),
    label: label,
    labelAriaProps: match$2.labelProps,
    tooltip: props.tooltip,
    errorMessage: errorMessage,
    required: props.required,
    ref: match[0]
  });
}

let make = React.memo(InputTextAreaField);

export {
  make,
}
/* make Not a pure module */
